import TrackerWrapper from './tracker';
import authorizationStore from './api/authorizationStore';

const trackEvents = (eventname, participantId) => {
  const tracker = TrackerWrapper.getTracker();
  try {
    authorizationStore.getToken().then((token) => {
      tracker.track(eventname, {
        'Participant User ID': `${authorizationStore.getCurrentLoggedInParticipantId(token)}`,
        // Organisation id attribute is not clear on the UI side to know for which user or event this
        // org id is belong to. so commenting this attribute now but need to revisit
        // 'Organisation ID': `${authorizationStore.getCurrentLoggedInRxOrgId(token)}`,
        'Participant ID': participantId,
        'Product Area': 'Participant'
      });
    });
  } catch (error) {
    console.error(error);
  }
};

const trackInteractedEvents = (eventname, participantId, interactedElement) => {
  const tracker = TrackerWrapper.getTracker();
  try {
    authorizationStore.getToken().then((token) => {
      tracker.track(eventname, {
        'Participant User ID': `${authorizationStore.getCurrentLoggedInParticipantId(token)}`,
        'Participant ID': participantId,
        'Interacted Element': interactedElement,
        'Product Area': 'Participant'
      });
    });
  } catch (error) {
    console.error(error);
  }
};

const trackGenericMixpanelEvents = (eventname, additionalProps) => {
  const tracker = TrackerWrapper.getTracker();
  try {
    authorizationStore.getToken().then((token) => {
      let totalProps = {
        'Participant User ID': `${authorizationStore.getCurrentLoggedInParticipantId(token)}`, 'Product Area': 'Participant'
      };
      totalProps = { ...totalProps, ...additionalProps };
      tracker.track(eventname, totalProps);
    });
  } catch (error) {
    console.error(error);
  }
};

export default { trackEvents, trackInteractedEvents, trackGenericMixpanelEvents };
